import { createSelector } from '@reduxjs/toolkit';

export const selectorForSelectedFilter = createSelector(
  (state) => state.analyticsfilter,
  (filter) => {
    return {
      LOB: filter.LOB,
      LOBTeam: filter.LOBTeam,
      LOBTeamAgent: filter.LOBTeamAgent
    };
  }
);
